import type ShouldAllowDownloadQRCode from './types';

const shouldAllowDownloadQRCode: ShouldAllowDownloadQRCode = false;

export default shouldAllowDownloadQRCode;
